// frontend/admin-portal/src/routes/domains/supplierRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import { PermissionRoute } from "@fiberhome/shared-ui";

import Suppliers from "../../pages/Suppliers";
import SupplierDetail from "../../pages/SupplierDetail";

export default function SupplierRoutes() {
  return (
    <Route element={<PermissionRoute permission="suppliers.read" />}>
      <Route path="suppliers" element={<Suppliers />} />
      <Route path="suppliers/:id" element={<SupplierDetail />} />
    </Route>
  );
}
